import type { FC } from 'react';

interface Props {
  className?: string;
}

const WalkingTrailIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM9 7v4l-2 8h-1l3-8.5V7zM13 12l2-2 1 1-2 2v8h-1v-8z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M2 18h20M3 15l3 3-3 3M21 15l-3 3 3 3"
      />
    </svg>
  );
};

export default WalkingTrailIcon;
